<template>
  <v-dialog
    v-model="showDialog"
    width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        class="px-4"
        :outlined="isOutlinedOpenBtn"
        color="#B50000"
        :disabled="isLoading || selectedTags.length == 0"
        @click="showDialog = true"
        style="text-transform: none;"
      >
        <v-icon v-if="$vuetify.breakpoint.xsOnly && isOpenDialogIconMobile">
          mdi-delete
        </v-icon>
        <span v-else>
          {{ $tc("removeTags", selectedTags.length) }}
        </span>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar elevation="0">
        <v-toolbar-title>{{ $t("attention") }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="showDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text
        class="text-subtitle-1 pa-6"
        :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
      >
        <v-alert
          border="left"
          colored-border
          type="info"
          color="#B50000"
          elevation="2"
        >
          <span style="font-size: 12px; font-weight: 400;">
            {{ $t("irreversibleAction") }}
          </span>
        </v-alert>

        <div>{{ $t("confirmRemoveTagText")}}</div>
      </v-card-text>

      <v-card-actions class="pa-6">
        <v-spacer></v-spacer>
        <v-btn
          class="px-4"
          outlined
          :disabled="isLoading"
          @click="showDialog = false"
          style="text-transform: none;"
        >
          {{ $t("toCancel") }}
        </v-btn>
        <v-btn
          class="ml-4 px-4 white--text"
          color="#B50000"
          :loading="isLoading"
          :disabled="isLoading"
          @click="removeTag"
          style="text-transform: none;"
        >
          {{ $tc("removeTags", selectedTags.length) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmRemoveTags",

  props: ["selectedTags", "isOutlinedOpenBtn", "isOpenDialogIconMobile"],

  data: () => ({
    showDialog: false,
    isLoading: false,
  }),

  methods: {
    removeTag() {
      this.isLoading = true;

      const selectedIdTags = this.selectedTags.map((tag) => tag.id);

      this.$axios.post(`${this.$prefix()}/tags/removeTags`, {
        tag_ids: selectedIdTags,
      })
      .then((res) => {
        this.$store.commit("setFeedbackSnack", {
          msg: res.data.messages,
          color: "success",
        });

        this.$emit("emitUpdateListTags");
        this.showDialog = false;
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
  },
}
</script>